import { IonContent, IonPage } from '@ionic/react';
import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import DesktopHeader from '../components/reusable-components/desktop-header/DesktopHeader';
import { HomeMessages } from '../intl/HomeMessages';
import { OrganizationSubscriptionsTable } from '../components/organizations/OrganizationSubscriptionsTable';
import { ListOrganizationsRequest } from '../models/organization';
import { createNextState } from '@reduxjs/toolkit';
import { useSearchOrganizationsQuery } from '../redux/api/organizations';
import { englishOnlyIntl, useGA4 } from '../utils/ga4';

export const OrganizationSubscriptionsPage: React.FC = () => {
  document.title = englishOnlyIntl.formatMessage(HomeMessages.subscriptionPageHeader);
  useGA4();

  const { formatMessage } = useIntl();

  const [orgRequest, setOrgRequest] = useState<ListOrganizationsRequest>({
    statuses: ['active'],
    pageNumber: 0,
    pageSize: 10,
    sort: { order: 'asc', property: 'orgName' },
  });

  const { data: organizationResults, isLoading } = useSearchOrganizationsQuery(orgRequest, {
    refetchOnMountOrArgChange: true,
  });

  const handleQueryChange = useCallback((requestUpdates: Partial<ListOrganizationsRequest>) => {
    setOrgRequest(
      createNextState(draft => {
        Object.assign(draft, requestUpdates);
      }),
    );
  }, []);

  return (
    <IonPage>
      <DesktopHeader title={formatMessage(HomeMessages.subscriptionPageHeader)} />
      <IonContent>
        <OrganizationSubscriptionsTable
          request={orgRequest}
          data={organizationResults}
          loading={isLoading}
          onTableChange={handleQueryChange}
        />
      </IonContent>
    </IonPage>
  );
};
